jQuery( document ).ready( function( $ ) {

	const $body = $( 'body' );

	/**
	 * add an 'upsell block' to the modal before 'add to cart' buttons are initialized
	 */
	$body.bind( 'ColibriEvent:AFTER_MODAL_UPDATED', ( event, data ) => {
		let $upsellBlock = $( '.modal--quick-view .upsell-block' );
		if ( $upsellBlock.length ) {
			const content = `
					<p class="upsell-block__text">This course is <b>FREE with Membership!</b></p>
					<h4 class="upsell-block__name"></h4>
					<div class="upsell-block__pricing">
						<div class="price">
							<span class="price-icon">$</span>
							<span class="price-amount"></span>
							<span class="price-period"></span>
						</div>
					</div>
					<div class="btn-wrapper"></div>
				`;
			$upsellBlock.html( content );
			// append an 'Add to Cart' btn to upsell block(data-product-code attr will be updated after API response on ColibriEvent:AFTER_STATUS_CHECK event)
			const $upsellAddToCart = $( '.modal--quick-view .product-actions .add-to-cart-container' ).clone();
			$upsellAddToCart.removeAttr( 'data-product-code' ).removeAttr( 'data-alt-product-code' );
			$upsellAddToCart.removeAttr( 'data-partnership-group-item-id' );
			$upsellAddToCart.appendTo( $upsellBlock.find( '.btn-wrapper' ) );
		}
	} );

	/**
	 * update upsell block after API response
	 */
	$body.bind( 'ColibriEvent:AFTER_STATUS_CHECK', ( event, data ) => {
		let $upsellBlock = $( '.modal--quick-view .upsell-block' ).first();
		let $upsellCartContainer = $upsellBlock.find( '.add-to-cart-container' ).first();

		if ( $upsellBlock.length === 0 ) return false;

		if ( data && Array.isArray( data.response ) && data.response.length > 0 && data.response[ 0 ]?.Properties ) {
			const response = data.response[ 0 ];

			const upsellMembershipProductCode = response.Properties?.UpsellMembershipProductCode;
			if ( upsellMembershipProductCode && $upsellCartContainer.attr( 'data-product-code' ) === upsellMembershipProductCode ) {
				//the add to card button in the upsell widget is already fully initialized
				return;
			}

			if ( !upsellMembershipProductCode ) {
				$upsellBlock.addClass( 'hide' );
				return;
			}

			if ( $upsellCartContainer.attr( 'data-product-code' ) ) {
				//will destroy the association between the old product code and the upsell button
				$body.trigger( 'ColibriEvent:UNINDEX_ADD_TO_CART', [$upsellCartContainer] );
			}

			if ( data?.add_to_cart_requested && data?.add_to_cart_requested.length > 0 ) {
				// if membership has been already added to the cart
				if ( data?.add_to_cart_requested.indexOf( response.Properties?.UpsellMembershipProductCode ) !== - 1 ) {
					$upsellCartContainer.find( '.add-to-cart' ).addClass( 'hidden' );
					$upsellCartContainer.find( '.checkout' ).removeClass( 'hidden' );
				}
			}

			let upsellMembershipName = response.Properties?.UpsellMembershipName;
			let upsellMembershipPrice = response.Properties?.UpsellMembershipPrice ?? '0';
			let upsellMembershipMonths = response.Properties?.UpsellMembershipMonths;
			let upsellMembershipPriceFormatted = parseInt( upsellMembershipPrice.replace( /,/g, '' ) );
			let upsellMembershipPriceAffirm = upsellMembershipPriceFormatted * 100;
			let inMembership = response.Properties?.InMembership;
			let upsellPricePeriod = "";

			let affirmMessage = '';
			if ( typeof window.colibri !== 'undefined' && typeof window.colibri.affirmPriceThreshold !== 'undefined' && window.colibri.affirmPriceThreshold <= upsellMembershipPriceFormatted ) {
				affirmMessage = `<div class="affirm-as-low-as" data-page-type="product" data-amount="${upsellMembershipPriceAffirm}"></div>`;
			}

			$upsellCartContainer.attr( 'data-product-code', upsellMembershipProductCode );
			$( window ).triggerHandler( 'ColibriEvent:INIT_ALL_ADD_TO_CARTS', [$upsellBlock] );

			if ( !inMembership
				&& upsellMembershipProductCode
				&& upsellMembershipName
				&& upsellMembershipPrice ) {
				$upsellCartContainer.attr( 'data-immediate-checkout', 1 );
				$upsellBlock.find( '.upsell-block__name' ).text( upsellMembershipName );
				$upsellBlock.find( '.price-amount' ).text( upsellMembershipPrice );

				if ( !$upsellBlock.find( '.affirm-as-low-as' ).length ) {
					$upsellBlock.find( '.upsell-block__pricing' ).after( affirmMessage );
				}

				// get discount price from the DB
				$.ajax( {
					url: window.colibri.admin_ajax,
					type: 'GET',
					data: {
						'action': 'get_upsell_discount',
						'productCode': upsellMembershipProductCode
					},
					success: function( response ) {
						if ( response && response?.discounted_price ) {
							let priceFormatted = response.discounted_price * 100;
							let discountedPrice = response.discounted_price.toString();

							// Check if discount price has only one digit after decimal point
							if ( discountedPrice.indexOf( '.' ) !== - 1 ) {
								let parts = discountedPrice.split( '.' );
								if ( parts[ 1 ].length === 1 ) {
									discountedPrice = discountedPrice + '0';
								}
							}

							if ( !$upsellBlock.find( '.discounted-price' ).length ) {
								$upsellBlock.find( '.upsell-block__pricing' ).prepend( `
										<div class="discounted-price">
											<span class="price-icon">$</span>
											<span class="price-amount">${discountedPrice}</span>
											<span class="price-period">${upsellPricePeriod}</span>
										</div>
									` );
								$upsellBlock.find( '.affirm-as-low-as' ).attr( 'data-amount', priceFormatted );
							} else {
								$upsellBlock.find( '.discounted-price' ).html( `
										<span class="price-icon">$</span>
										<span class="price-amount">${discountedPrice}</span>
										<span class="price-period">${upsellPricePeriod}</span>
									` );
								$upsellBlock.find( '.affirm-as-low-as' ).attr( 'data-amount', priceFormatted );
							}

							const displayText = response.promo_rate_text?.trim() ? 'off with code:' : 'With Promo Code:';
							if ( !$upsellBlock.find( '.discount-info' ).length ) {
								$upsellBlock.find( '.upsell-block__pricing' ).append( `
										<div class="discount-info">
											<span class="promo-rate">${response.promo_rate_text}</span>
											<span class="text-to-display">${displayText}</span>
											<span class="promo-code-text">${response.promo_code_text}</span>
										</div>
									` );
							} else {
								$upsellBlock.find( '.discount-info' ).html( `
                                        <span class="promo-rate">${response.promo_rate_text}</span>
                                        <span>${displayText}</span>
                                        <span class="promo-code-text">${response.promo_code_text}</span>
                                    ` );
							}
						}
						$upsellCartContainer.attr( 'data-payment-option-id', response.payment_option_id );
						$upsellBlock.removeClass( 'hide' );

						if ( response?.payment_option_id === 0 ) {
							upsellPricePeriod = "";
						} else {
							if ( upsellMembershipMonths === "12" ) {
								upsellPricePeriod = "/year";
							} else if ( upsellMembershipMonths === "24" ) {
								upsellPricePeriod = "/2 years";
							}
						}
						$upsellBlock.find( '.price-period' ).text( upsellPricePeriod );
					},
					error: function( response ) {
						console.log( 'response error: ', response );
						$upsellBlock.removeClass( 'hide' );
					},
				} );

			}

			if ( typeof window.affirm !== 'undefined' ) {
				window.affirm.ui.ready( function() {
					window.affirm.ui.refresh();
				} );
			}
		}
	} );

	/**
	 * add also a product to the cart if a membership addToCart btn was clicked
	 */
	$body.bind( 'ColibriEvent:DO_ADD_TO_CART_SUCCESS', ( event, cart ) => {
		const $target = $( '.modal--quick-view' );
		if ( $target.find( '.upsell-block' ).length !== 0 ) {
			$target.find( '.product-actions .add-to-cart button' ).trigger( 'click' );
			$body.unbind( 'ColibriEvent:DO_ADD_TO_CART_SUCCESS' );
		}
	} );
} );
